var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgDoorAuto(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "currentColor"
  }, /*#__PURE__*/React.createElement("path", {
    id: "svg_1",
    d: "m16,11l2,0l0,2l-2,0l0,-2m-4,-8l7,0c1.11,0 2,0.89 2,2l0,14l1,0l0,2l-20,0l0,-2l8,0l0,-14c0,-1.11 0.89,-2 2,-2m0,2l0,14l7,0l0,-14l-7,0z"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "null",
    d: "m4.73196,4.75644l0,1.20232l1.60309,-1.60309l-1.60309,-1.60309l0,1.20232a3.20619,3.20619 0 0 0 -3.20619,3.20619c0,0.62921 0.18436,1.21434 0.49696,1.70729l0.58513,-0.58513c-0.18035,-0.33264 -0.28054,-0.72139 -0.28054,-1.12216a2.40464,2.40464 0 0 1 2.40464,-2.40464m2.70923,0.69735l-0.58513,0.58513c0.17634,0.33665 0.28054,0.72139 0.28054,1.12216a2.40464,2.40464 0 0 1 -2.40464,2.40464l0,-1.20232l-1.60309,1.60309l1.60309,1.60309l0,-1.20232a3.20619,3.20619 0 0 0 3.20619,-3.20619c0,-0.62921 -0.18436,-1.21434 -0.49696,-1.70729z"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDoorAuto);
export default __webpack_public_path__ + "static/media/doorAuto.060b8e68.svg";
export { ForwardRef as ReactComponent };